import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import BreadCrumb from '../../components/BreadCrumb';
import Metadata from '../../components/Metadata';
import { fetchPage } from '../../store/actions';
import { sanitizeHtml } from '../../utils/commonFunctions';

/**
 * InfoPage Component
 * - Displays informational content for a specific page based on the provided name.
 * - Fetches and renders page content dynamically using Redux.
 * - Includes breadcrumb navigation and metadata for SEO purposes.
 */
const InfoPage = ({ name, nameKey, page, fetchPage, location }) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        fetchPage({ link: location.pathname, locale: i18n.language });
    }, [fetchPage, location.pathname, i18n.language]);

    return (
        <>
            <Metadata
                title={name}
                description={name}
                url={`${process.env.REACT_APP_BASE_PAGE_URL}/${name}`}
            />
            <BreadCrumb className="shadow5 info_page" title={t(nameKey)}>
                <>
                    <div className="space-10" />
                    <div className="row">
                        <div className="col-12">
                            <div className="info_content">
                                {page && page.content && (
                                    <div
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{
                                            __html: sanitizeHtml(
                                                page.content
                                            ).replace(
                                                /href/g,
                                                "target='_blank' href"
                                            ),
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </>
            </BreadCrumb>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        page: (state.page && state.page.page && state.page.page.data[0]) || [],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPage: ({ link, locale }) => dispatch(fetchPage({ link, locale })),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoPage);
